
const dateFormat = require('bmh/date-format');
import { namespace } from 'vuex-class';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import training_needs from "@/common/training_needs";
const qs = require('qs');

const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_reach_msg: `${FCAPI}/boss/hundun/work/temporary/user`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  user_detail: `${FCAPI}/boss/hundun/user`,
  get_log: `${FCAPI}/boss/hundun/user/log`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  put_relevance: `${FCAPI}/boss/hundun/user/company`,
  edit_info: `${FCAPI}/boss/hundun/company`,
  edit_industry: `${FCAPI}/boss/hundun/company/attribute`,
  tag_get_list: `${FCAPI}/boss/hundun/setting/tag/search`,
};

function validateMapFormat() {
  return {
    full_name: {
      value: '',
      status: '',
      help: ''
    },
    is_keyman: {
      value: 1,
      status: '',
      help: ''
    }
  };
}

@Component
export default class UserDetail extends Vue {
  /* eslint-disable */
  tag_list: any = []; //标签
  ai_tag_list: any = []; //智能标签
  // @ts-ignore
  @Hundun.State('online_student_status') online_student_status: any; //线上学籍
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('offline_students_status') offline_students_status: any; //线下学籍
  // @ts-ignore
  @Hundun.State('identity') identity: any; //身份
  // @ts-ignore
  @Hundun.State('follow_status') follow_status: any; //跟进状态选项
  // @ts-ignore
  @Hundun.State('training_need') training_need: any; //待解决问题
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社
  // @ts-ignore
  @Hundun.State('cooperation_selects') cooperation_selects: any; //合作
  /* eslint-enable */
  get branch_widthout_all() {
    return this.branch_office.slice(1);
  }
  get teacher_widthout_all() {
    let s = [...this.teacher_list];
    s.pop();
    return s.slice(1);
  }
  readAiTagList(tree: any) {
    const result: any[] = [];
    tree.forEach((item: any) => {
      const newItem = { ...item };
      if (item.parent) {
        newItem.parent = this.readAiTagList(item.parent);
      }
      if (item.is_ai || newItem.parent?.length > 0) {
        result.push(newItem);
      }
    });
    return result;
  }
  get identity_without_all() {
    return [
      {
        id: 1,
        value: '领教'
      },
      {
        id: 2,
        value: '助教'
      },
      {
        id: 3,
        value: '辅导员'
      },
      {
        id: 4,
        value: '超级链接者'
      },
      {
        id: 99,
        value: '无'
      }
    ];
  }
  get follow_status_without_all() {
    return [
      {
        id: '1',
        value: '已加'
      },
      {
        id: '2',
        value: '团报'
      },
      {
        id: '3',
        value: '删'
      },
      {
        id: '4',
        value: '微信待通过'
      },
      {
        id: '5',
        value: '已发短信'
      },
      {
        id: '6',
        value: '微信非手机号'
      },
      {
        id: '7',
        value: '已电话沟通'
      },
      {
        id: '8',
        value: '活动分配'
      },
      {
        id: '99',
        value: '其他'
      }
    ];
  }
  get training_needs() {
    return training_needs;
  }
  // 待解决问题
  // training_needs = ;
  //企业类型
  corp_type = [
    {
      id: 0,
      value: '无'
    },
    {
      id: 1,
      value: '国企'
    },
    {
      id: 2,
      value: '私企'
    }
  ];
  //是否关键人
  keyman = [
    {
      id: 0,
      value: '否'
    },
    {
      id: 1,
      value: '是'
    },
    {
      id: 2,
      value: '不确定'
    }
  ];
  //是否兔必
  tob = [
    {
      id: 0,
      value: '否'
    },
    {
      id: 1,
      value: '是'
    },
    {
      id: 2,
      value: '不确定'
    }
  ];

  get is_tob_label() {
    let label = '';
    this.tob.some((tob) => {
      if (tob.id === this.user_detail?.company?.is_tob) {
        label = tob.value;
        return true;
      }
    });
    return label;
  }

  // 企业规模
  corp_scale = [
    {
      id: 1,
      value: '0-50'
    },
    {
      id: 2,
      value: '50-100'
    },
    {
      id: 3,
      value: '100-500'
    },
    {
      id: 4,
      value: '500以上'
    }
  ];
  show_add_tag = false;
  tag_value = [];
  last_offline_status: any[] = []; //取消全部的线下
  last_cooperation_select: any[] = []; //去掉全部的合作
  is_loading = false;
  locale = zhCN;
  text_title = ''; //编写需求弹框标题
  form: any;
  user: any = {};
  modal_title = '';
  wechat_list: any[] = [];
  show_edit_modal = false;
  user_detail: any = {}; //用户详情
  user_id = 0;
  show_text_modal = false; //编写培训需求
  log = ''; //备注
  user_log = []; //跟进记录
  text = '';
  reach_msg = [];
  show_relevance_modal = false;
  ref_show_tub = false;
  ref_company_is_tub = 0;
  validate_map: any = validateMapFormat();
  income: any = 0;
  dataSource: any = [];
  window = window as any;
  company_id = 0;
  tag_type = 0;

  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  chooseTob() {
    this.ref_show_tub = true;
  }

  handleConfirmTob() {
    this.ref_show_tub = false;
    this.editCompanyDetail();
  }

  addTag(type: number) {
    this.tag_value = [];
    this.show_add_tag = true;
    this.tag_type = type;
  }
  addAiTag() {
    this.addTag(3);
  }
  confirm_add() {
    const value = this.tag_value.pop();
    this.editDetail('tag', value);
    this.show_add_tag = false;
  }
  editIntro(text: any) {
    this.text = text;
    this.text_title = '编辑公司简介';
    this.show_text_modal = true;
  }
  //确认编辑
  confirmEdit() {
    if (this.text_title === '编辑公司简介') {
      this.user_detail.company.wiki = this.text;
      this.editCompanyDetail();
      // this.editDetail('corp_intro', this.text);
      // this.getUserDetail();
    } else if (this.text_title === '编辑能提供的福利') {
      this.editDetail('advantage', this.text);
    } else {
      this.editDetail('shareable', this.text);
    }

    this.show_text_modal = false;
  }
  //编辑微信号
  editWechat() {
    this.modal_title = '微信号';
    this.show_edit_modal = true;
    this.wechat_list = [...this.user_detail.wechat];
    console.log('user_detail', this.user_detail);
  }
  // 编辑手机号
  editPhone() {
    this.modal_title = '关联手机号';
    this.show_edit_modal = true;
    this.wechat_list = [...this.user_detail.relation_mobile];
  }
  editShareable(text: any) {
    this.text_title = '编辑能分享的知识技能';
    this.text = text;
    this.show_text_modal = true;
  }
  editAdvantage(text: any) {
    this.text_title = '编辑能提供的福利';
    this.text = text;
    this.show_text_modal = true;
  }
  //提交编辑
  editWechatAndPhone() {
    let send_data: any = [];
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        for (const key in values) {
          console.log(key);
          send_data.push(values[key]);
        }
        if (this.modal_title === '关联手机号') {
          this.editDetail('relation_mobile', send_data);
        } else {
          this.editDetail('wechat', send_data);
        }
        this.show_edit_modal = false;
      } else {
        return;
      }
    });
  }
  //临时删除微信号
  deleteWechat(index: number) {
    this.wechat_list.splice(index, 1);
  }
  // 新增
  add() {
    this.wechat_list.push('');
  }
  //编辑回访时间
  changeVisitTime(value: any) {
    const visit_time = value ? Math.floor((value as any).format('x') / 1000) : 0;
    this.editDetail('visit_time', visit_time);
  }
  //获取用户详情
  async getUserDetail() {
    this.is_loading = true;
    const res: any = await this.$axios.get(`${API.user_detail}/${this.user_id}`);
    if (res.status === 200) {
      if (res.data.data.company) {
        res.data.data.company.employees_number = res.data.data.company.employees_number ? res.data.data.company.employees_number : '';
      }
      this.user_detail = res.data.data;
      // this.user_detail.company = this.user_detail.company ? this.user_detail.company : null;
      console.log(this.user_detail);
      let coopeartion = [];
      this.user_detail.cooperation ? coopeartion.push(this.user_detail.cooperation) : '';
      this.user_detail.cooperation_sub ? coopeartion.push(this.user_detail.cooperation_sub) : '';
      this.user_detail.cooperation = coopeartion;
      this.user_detail.visit_time = this.user_detail.visit_time === 0 ? '' : moment(this.user_detail.visit_time * 1000);
      this.user_detail.user_teacher = this.user_detail.user_teacher.map((item: any) => item.teacher_id);
      this.user_detail.corp_type = this.user_detail.corp_type === 0 ? '' : this.user_detail.corp_type;
      this.wechat_list = [...this.user_detail.wechat];
      // if (this.user_detail.offline_status[0] === '0') {
      //   this.user_detail.offline_status = [];
      // }
      if (this.user_detail.charge_teacher_id === 0) {
        this.user_detail.charge_teacher_id = [];
      }
      if (this.user_detail.identity === 0) {
        this.user_detail.identity = '请选择';
      }
      if (this.user_detail.corp_scale === 0) {
        this.user_detail.corp_scale = '';
      }
      if (this.user_detail.branch_id === 0) {
        this.user_detail.branch_id = '';
      }
      if (this.user_detail.offline_status[0] === '0') {
        this.user_detail.offline_status = [];
      }
      this.is_loading = false;
      this.income = this.user_detail.company == null ? '' : Number(this.user_detail.company.income) / 10000;
    }
  }
  //精确到秒
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  //精确到天
  dateFormat2(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }
  change() {
    console.log('11');
  }
  //添加备注
  async addLog() {
    if (!this.log) {
      this.$message.error('请输入备注');
      return;
    }
    const send_data = {
      user_id: this.user_id,
      content: `备注  “${this.log}”`
    };
    const res: any = await this.$axios.post(API.get_log, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      this.getUserDetail();
      this.getUserLog();
    }
    this.log = '';
  }
  async getReachMsg() {
    this.is_loading = true;
    const res = await this.$axios.get(`${API.get_reach_msg}?user_id=${this.user_id}&menu_id=${this.$route.query.menu_id}`);
    if (res.data.status === 200) {
      this.reach_msg = res.data.data;
      this.is_loading = false;
    }
    console.log(res);
  }
  //获取备注列表
  async getUserLog() {
    this.is_loading = true;
    const res: any = await this.$axios.get(`${API.get_log}?user_id=${this.user_id}`);
    this.user_log = res.data.data;
    this.is_loading = false;
  }
  // 编辑企业信息
  async editCompanyDetail() {
    console.log(this.user_detail.company);

    const income = this.income * 10000;
    const res = await this.$axios.put(`${API.edit_info}/${this.user_detail.company.id}`, { ...this.user_detail.company, income: income });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('编辑成功');
  }
  //编辑属性
  async editDetail(column: string, value: any) {
    if (column === 'cooperation' && value.length === 1) {
      //合作如果是1级则二级放空
      value.push('');
    }
    if (column === 'corp_scale' && !value) {
      value = 0;
    }
    const send_data = {
      column: column,
      value: value
    };
    console.log(this.user_id);

    const res = await this.$axios.put(`${API.edit_user_detail}/${this.user_id}?menu_id=${this.$route.query.menu_id}`, send_data);
    this.getUserDetail();
    if (column === 'charge_teacher_id' || column === 'teacher_id') {
      this.getUserLog();
    }
    if (res.status === 200) {
      if (column == 'corp_industry') {
        this.user_detail.company.industry = this.user_detail.corp_industry;
        return this.editCompanyDetail();
      }
      this.$message.success('编辑成功');
      console.log(res);
    }
  }
  async editIndustryDetail(column: any, value: any) {
    try {
      console.log(this.user_detail.company_id);

      if (this.user_detail.company_id !== 0) {
        await this.$axios.put(`${API.edit_industry}/${this.user_detail.company_id}?menu_id=${this.window.route_menu_id}`, { column: column, value: value });
      } else await this.$axios.put(`${API.edit_user_detail}/${this.user_id}?menu_id=${this.window.route_menu_id}`, { column: 'corp_industry', value: value });
      this.$message.success('修改成功');
      this.getUserDetail();
    } catch (error) {
      this.$message.error('修改失败');
    }
  }
  //标签删除
  async deleteTag(id: number) {
    this.is_loading = true;
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      this.getUserDetail();
      return;
    }
    this.is_loading = false;
  }
  async autoCompleteChange(value: any) {
    if (value == '') return (this.dataSource = []);
    const url = `${API.edit_info}?${qs.stringify({
      full_or_part_name: value,
      current: 1,
      limit: 9999
    })}`;
    const res: any = await this.$axios.get(url);
    let company_list: Array<any> = [];
    if (res.data?.data?.detail) {
      company_list = res.data?.data?.detail.map((element: any) => element.full_name);
    }
    this.dataSource = Array.from(new Set(company_list));
    console.log(company_list);
  }

  showRelevanceModal() {
    this.validate_map = validateMapFormat();
    this.show_relevance_modal = true;
  }

  async confirmRelevanceEdit() {
    if (!this.validate_map.full_name.value) {
      this.validate_map.full_name.status = 'error';
      this.validate_map.full_name.help = '请输入企业名称';
      return;
    }
    const send_data = {
      full_name: this.validate_map.full_name.value,
      is_keyman: this.validate_map.is_keyman.value
    };
    const res: any = await this.$axios.put(`${API.put_relevance}/${this.$route.params.id}`, send_data);
    if (res.data.status === 200) {
      this.$message.success('关联成功');
      this.show_relevance_modal = false;
      this.getUserDetail();
    }
    if (res.data.status === 500) {
      this.validate_map.full_name.status = 'error';
      this.validate_map.full_name.help = res.data.message;
    }
    console.log(this.$route.params.id);
  }
  async getTags() {
    const res: any = await this.$axios.get(`${API.tag_get_list}`, {
      params: {
        is_all: 1
      }
    });
    if (res.data.status === 200) {
      this.tag_list = res.data.data;
      this.ai_tag_list = this.readAiTagList(this.tag_list);
    } else {
      this.$message.error(res.data.message);
    }
  }
  beforeCreate() {
    this.form = this.$form.createForm(this);
  }
  created() {
    this.last_offline_status = this.offline_students_status.slice(1);
    this.last_offline_status.pop();
    this.last_cooperation_select = this.cooperation_selects.slice(1);
    // this.last_cooperation_select.pop();
    this.user_id = +this.$route.params.id;
    this.getUserDetail();
    this.getUserLog();
    this.getReachMsg();
    this.getTags();
  }
}
